import React from 'react';

import BaseSvg from '../../BaseSvg';
import { InjectedSvgProps } from '../../hocs';

export default class BonusNegativeSvg extends React.PureComponent<InjectedSvgProps> {
    render() {
        const { fillColor, className } = this.props;

        let classNames: Array<string> = ['ddbc-bonus-negative-svg'];

        if (className) {
            classNames.push(className);
        }

        return (
            <BaseSvg className={classNames.join(' ')} viewBox="0 0 41 47.21997">
                <g id="BonusNegativeSvg-4c9b50cd-f375-4708-a2a2-d124a51f0d1b" data-name="Layer 2">
                    <g id="BonusNegativeSvg-9ac5fc9e-1687-4992-9bdf-bc4b4bca2cb2" data-name="Advantage">
                        <path
                            fill={fillColor}
                            d="M40.89,11.71,20.39,0,0,11.9.11,35.51l20.5,11.71L41,35.32ZM28.5,27.07h-16V20.15h16Z"
                        />
                    </g>
                </g>
            </BaseSvg>
        );
    }
}
